import { render } from "./MoreORLess.vue?vue&type=template&id=bc0ba64c&scoped=true"
import script from "./MoreORLess.vue?vue&type=script&lang=js"
export * from "./MoreORLess.vue?vue&type=script&lang=js"

import "./MoreORLess.vue?vue&type=style&index=0&id=bc0ba64c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0ba64c"]])

export default __exports__